// extracted by mini-css-extract-plugin
export default {"content":"BannerSlides_content__bXISN","content2":"BannerSlides_content2__RRxqL","content3":"BannerSlides_content3__T7iNR","link":"BannerSlides_link__k1wtL"};